const AffiliateProgram = () => import('../views/affiliateprogram/AffiliateProgram.vue');

// nessuna guardia: l'autenticazione dell'affiliato la gestisce il componente tramite il suo store,
// come per il PartnerProgram. `meta.affiliateHost` permette ad App.vue di usare il layout dedicato
// anche in locale, senza dover puntare all'host reale.
export default [
	{
		path: '/affiliateprogram',
		name: 'affiliateprogram',
		component: AffiliateProgram,
		meta: { affiliateHost: true },
	},
];
